/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `core/pages/auth/AuthPage`, `core/pages/home/HomePage`).
 */

import React, { useEffect } from 'react';
import { Redirect, Route, Switch, withRouter, useLocation, useHistory } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import HomePage from '../pages/home/HomePage';
import LogoutPage from '../pages/auth/Logout';
import ErrorsPage from '../pages/errors/ErrorsPage';
import AuthPage from '../pages/auth/AuthPage';
import Recover from '../pages/auth/Recover';

export const Routes = withRouter(() => {
    const { isAuthorized, userLastLocation } = useSelector(
        ({ auth }) => ({
            isAuthorized: auth.user != null,
        }),
        shallowEqual
    );
    const location = useLocation();
    const history = useHistory();
    const isRecoverRoute = location.pathname === '/users/recover';

    useEffect(() => {
        if (!isRecoverRoute || !isAuthorized) return;
        localStorage.removeItem('sessionUser');
        localStorage.removeItem('newEmail');
        localStorage.setItem('recoverToken', location.search);
        history.push('/logout');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRecoverRoute]);

    return (

        <Switch>
            {!isAuthorized ? (
            /* Render auth page when user at `/auth` and not authorized. */
                <AuthPage />
            ) : (
            /* Otherwise redirect to root page (`/`) */
                <Redirect from="/auth" to='/clients' />
            )}
            <Route path="/users/recover" component={Recover} />

            <Route path="/error" component={ErrorsPage} />
            <Route path="/logout" component={LogoutPage} />

            {!isAuthorized ? (
            /* Redirect to `/auth` when user is not authorized */
                <Redirect to="/auth/login" />
            ) : (

                <HomePage userLastLocation={userLastLocation} />

            )}
        </Switch>
    );
});
